import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { API } from '../api';
import { withLanguage } from '../components/common/Texts';

// Drives the "request a password reset" screen: validates the user/email pair
// with the backend and, on success, forwards to the token-based reset screen.
export default function useResetPasswordRequest() {
    const navigate = useNavigate();
    const language = useSelector((state) => state.user.language);
    const t = withLanguage(language);

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        const cleanUsername = username.trim();
        const cleanEmail = email.trim();

        if (cleanUsername.length <= 1 || cleanEmail.length <= 1) {
            setError(t('request_password_reset_error_1'));
            return;
        }

        setError('');
        setLoading(true);
        try {
            const { data } = await API.post('/validate-reset-password-request/', {
                username: cleanUsername,
                email: cleanEmail,
            });
            if (!data?.token) {
                setError(t('request_password_reset_error_2'));
                return;
            }
            navigate(`/reset-password/${data.token}`);
        } catch (e) {
            console.error(e);
            setError(t('request_password_reset_error_2'));
        } finally {
            setLoading(false);
        }
    };

    return { username, setUsername, email, setEmail, error, loading, submit };
}
